import { createFileRoute } from '@tanstack/react-router'
import { PengaturanDesa } from '../../../../components/PengaturanDesa'
import { bacaSectionParam, type SectionPengaturan, useScrollToSection } from '../../../../hooks/useScrollToSection'

// G2: `?section=kop` / `?section=logo` dipakai kotak info di modul Template Surat agar petugas
// mendarat langsung di bagian yang dituju, bukan di puncak halaman pengaturan yang panjang.
export const Route = createFileRoute('/desa/$slug/dashboard/pengaturan')({
  component: PengaturanRoute,
  validateSearch: (search: Record<string, unknown>): { section?: SectionPengaturan } => ({
    section: bacaSectionParam(search.section),
  }),
})

function PengaturanRoute() {
  // `as any`: konteks route dashboard desa belum bertipe (pola yang sama dipakai route lain di shell ini).
  const { desaId } = Route.useRouteContext() as any
  const { section } = Route.useSearch()
  useScrollToSection(section)

  if (!desaId) return null
  return <PengaturanDesa desaId={desaId} />
}
